import { ROLE_WILDCARD_ONLYUSERS, ROLE_WILDCARD_PUBLIC, UnespCoreMenuItem } from "@unesp/core";

export const menu: UnespCoreMenuItem[] = [

  {
    displayName: 'Início',
    iconName: 'home',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: '',
    order: -1
  },
  {
    displayName: 'Área do candidato',
    iconName: 'assignment_ind',
    roles: [ROLE_WILDCARD_ONLYUSERS],
    order: 1,
    children: [
      {
        displayName: 'Inscrever-se',
        iconName: 'edit_document',
        roles: [ROLE_WILDCARD_ONLYUSERS],
        order: 1,
        route: 'candidatos/inscricoes-abertas'
      },
      {
        displayName: 'Perfil',
        iconName: 'person',
        roles: [ROLE_WILDCARD_ONLYUSERS],
        route: 'candidatos/perfil',
        order: 2
      },

      {
        displayName: 'Acompanhar inscrições',
        iconName: 'description',
        roles: [ROLE_WILDCARD_ONLYUSERS],
        order: 3,
        route: 'candidatos/minhas-inscricoes'
      },
    ]
  },
  {
    displayName: 'Eleições Institucionais',
    iconName: 'how_to_vote',
    roles: ['centralRoleResponsavelEleicaoInstitucional','centralRoleValidacaoLocal'],
    order: 3,
    children: [
      {
        displayName: 'Gerenciamento',
        iconName: 'settings',
        roles: ['centralRoleResponsavelEleicaoInstitucional'],
        route: 'eleicoes/institucionais/lista',
        order: 1
      },

      {
        displayName: 'Validação inscrições',
        iconName: 'manage_accounts',
        roles: ['centralRoleValidacaoLocal'],
        order: 2,
        route: 'eleicoes/institucionais/validacaolocal/lista'
      },
    ]
  },
  {
    displayName: 'Eleições',
    iconName: 'how_to_vote',
    roles: ['centralRoleResponsavelEleicao'],
    order: 2,
    route: 'eleicoes/lista',
  },
  {
    displayName: 'Acesso ESU',
    order: 5,
    roles: ['centralRoleESU'],
    iconName: 'support_agent',
    addTopDivider: true,
    smallSize: true,
    route: 'esu',
  },
  {
    displayName: 'Retornar à Central de Acessos',
    order: 6,
    roles: [ROLE_WILDCARD_PUBLIC],
    iconName: 'apps',
    addTopDivider: true,
    smallSize: true,
    route: 'central',
  },
];
